import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import constants from "../src/constants";

import { Provider } from "react-redux";
import store from "./store";

const params = new URLSearchParams(window.location.search);
const urlSignature = params.get("signature");
if (urlSignature && urlSignature !== "null") {
  sessionStorage.setItem("signature", urlSignature);
}

axios.defaults.baseURL = constants.DEFAULT_URL;

axios.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    const user = sessionStorage.getItem("user");
    const signature = sessionStorage.getItem("signature");

    if (signature && signature !== "null") {
      config.baseURL = constants.GATEWAY_URL;
      config.headers["X-Open-Signature"] = signature;
      if (user) {
        config.headers["X-User"] = user;
      }
    } else if (token && user) {
      config.baseURL = constants.DEFAULT_URL;
      config.headers["X-Authorization"] = token;
      config.headers["X-User"] = user;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();